import SignUpMain from "../components/auth/SignUpMain";

const SignUpPage = () => {
	return <SignUpMain />;
};

export default SignUpPage;
